import request from '@/utils/request';
import { datasetEndpoint } from '@/constants/urls';

const create = (code, name) => (
  request({
    data: { name },
    method: 'POST',
    url: `${datasetEndpoint(code)}/namespaces`,
  })
);

const destroy = (code, { id }) => (
  request({
    method: 'DELETE',
    url: `${datasetEndpoint(code)}/namespaces/${id}`,
  })
);

const namespaces = (code) => (
  request({
    method: 'GET',
    url: `${datasetEndpoint(code)}/namespaces`,
  })
);

const DatasetNamespaceService = {
  create,
  destroy,
  namespaces,
};

export default DatasetNamespaceService;
